/**
 * The install card.
 *
 * This is about the workspace as a whole rather than about one thing in it: is it connected?
 *
 * It used to carry four more calls — `/usage`, `/export`, and the two halves of `/onboarding`.
 * The current design export draws no screen for any of them, and by the rule recorded in
 * AGENTS.md that means they are removed rather than merely undrawn. **The endpoints still exist**
 * in `apps/handbook-mcp/app/api/v1/workspace.py`; they have no caller here. Re-transcribe them
 * from that module if a screen for one comes back.
 */

import { authed } from "./authed";
import type { WorkspaceStatus } from "./types";

/** "Is the thing I just installed working?" — the state is decided on the server. */
export function getStatus(signal?: AbortSignal): Promise<WorkspaceStatus> {
  return authed<WorkspaceStatus>("/status", { signal });
}
